"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _StatusMessageDto = _interopRequireDefault(require("../model/StatusMessageDto"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
* PatientScans service.
* @module 1/PatientScansApi
* @version 6.3.0
*/
var PatientScansApi = /*#__PURE__*/function () {
  /**
  * Constructs a new PatientScansApi. 
  * @alias module:1/PatientScansApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function PatientScansApi(apiClient) {
    _classCallCheck(this, PatientScansApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Deletes the patient scan with the specified identifier. (Requires: Roles -> RH.PS.Delete, SIASS.PS.D, SIASS.PS.Admin).
   * @param {String} id The patient scan identifier.
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */
  _createClass(PatientScansApi, [{
    key: "patientscansIdDeleteWithHttpInfo",
    value: function patientscansIdDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientscansIdDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = null;
      return this.apiClient.callApi('/patientscans/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Deletes the patient scan with the specified identifier. (Requires: Roles -> RH.PS.Delete, SIASS.PS.D, SIASS.PS.Admin).
     * @param {String} id The patient scan identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "patientscansIdDelete",
    value: function patientscansIdDelete(id) {
      return this.patientscansIdDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Downloads the patient scan with the specified identifier. (Requires: Roles -> RH.PS.Read, SIASS.PS.R, SIASS.PS.L, SIASS.PS.Admin).
     * The patient scan is returned as file stream containing a zip archive.
     * @param {String} id The patient scan identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link File} and HTTP response
     */
  }, {
    key: "patientscansIdGetWithHttpInfo",
    value: function patientscansIdGetWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientscansIdGet");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/octet-stream'];
      var returnType = File;
      return this.apiClient.callApi('/patientscans/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Downloads the patient scan with the specified identifier. (Requires: Roles -> RH.PS.Read, SIASS.PS.R, SIASS.PS.L, SIASS.PS.Admin).
     * The patient scan is returned as file stream containing a zip archive.
     * @param {String} id The patient scan identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */
  }, {
    key: "patientscansIdGet",
    value: function patientscansIdGet(id) {
      return this.patientscansIdGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return PatientScansApi;
}();
exports["default"] = PatientScansApi;